import Vue from 'vue'
import VueMeta from 'vue-meta'
import VueRouter, { RouteConfig } from 'vue-router'
import publicRoutes from '@/router/public'
import privateRoutes from '@/router/private'
import {
  authGuard,
  emailVerifiedGuard,
  memberGuard,
  featureGuard,
  resolve,
} from './guards'
import store from '@/store'
import { sessionGuard } from './guards/session'

Vue.use(VueRouter)
Vue.use(VueMeta)

const routes: Array<RouteConfig> = [
  ...publicRoutes,
  ...privateRoutes,
  {
    path: '*',
    redirect: 'notfound',
  },
]

export function setupVueRouter(routes: Array<RouteConfig>): VueRouter {
  const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
  })

  router.beforeEach(
    resolve([
      sessionGuard,
      authGuard,
      emailVerifiedGuard,
      memberGuard,
      featureGuard,
    ])
  )
  router.beforeResolve((to, from, next) => {
    store.dispatch('errors/clear')
    next()
  })

  return router
}

const router = setupVueRouter(routes)
export default router
